import { useEffect, useState } from 'react';
import Header from 'src/components/demo-day/header/Header';
import cx from '../demo-day/index.module.scss';
import st from '../demo-day-not-found/index.module.scss';
import { calendaricon, invitationicon, machine, scheduleicon } from 'src/assets/images';
import { clearDemoDay, getDemoDay } from 'src/store/venture/venture.slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import { useNavigate } from 'react-router-dom';
import { Button, Loader } from 'src/components/common';
import { formatDate } from 'src/utils';
import { calculateDuration, formatSmartDuration } from 'src/utils/calculateDuration/calculateDuration';
import { convertUTCDateToTime } from 'src/utils/convertUTCDateToTime/convertUTCDateToTime';
const DemoDayDetails = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { demoDay, ventureLoading } = useAppSelector(
        (store) => store.venture
    );
    const { paramValue } = useUrlParamValue();
    const ventureVerseId = paramValue({ paramName: 'id' });

    useEffect(() => {
        if (ventureVerseId !== 'undefined') {
            dispatch(getDemoDay({ ventureVerseId }))
        } else {
            navigate('/demo-day')
        }
        return () => {
            dispatch(clearDemoDay())
        }
    }, [ventureVerseId]);

    return (
        <div className={cx.demoDay}>
            <Header />
            <div className={cx.demoDayContent} style={{ paddingTop: 0 }}>
                <section className={st.content}>
                    {ventureLoading && <Loader />}
                    {!ventureLoading && demoDay?.id && <>
                        <div className={st.left}>
                            <div className={st.leftContent}>
                                <h5 className={st.title}>Demo Day</h5>
                                <div className={st.successHeader}>
                                    <span className={st.icon}>✅</span>Booking Confirmed
                                </div>
                                <h5>Booking Details</h5>
                                <p><img src={calendaricon} alt="date" /> <span className={st.timing}>{formatDate({ dateString: demoDay?.bookingDetails?.date })}</span></p>
                                <p><img src={scheduleicon} alt="schedule" /> <span className={st.timing}>{convertUTCDateToTime(demoDay?.bookingDetails?.startTime)} - {convertUTCDateToTime(demoDay?.bookingDetails?.endTime)}</span></p>

                                {demoDay?.bookingDetails?.startTime && demoDay?.bookingDetails?.endTime ? (
                                    <p><strong>Duration:</strong> {formatSmartDuration(calculateDuration(demoDay?.bookingDetails?.startTime, demoDay?.bookingDetails?.endTime))}</p>
                                ) : (
                                    <p><strong>Duration:</strong> N/A</p>
                                )}
                                {demoDay?.paymentDetails?.order_id && <>
                                    <h5>Payment Details</h5>
                                    <p>Amount: <strong> {demoDay?.paymentDetails?.amount ? `${demoDay?.paymentDetails?.amount / 100} INR` : '--'}</strong></p>
                                    <p>Order Id: <strong> {demoDay?.paymentDetails?.order_id}</strong></p>
                                    <p>Receipt: <strong> {demoDay?.paymentDetails?.receipt}</strong></p>
                                </>}
                                <p>
                                    <img src={invitationicon} alt="invitation-icon" />
                                    <strong>
                                        <a
                                            href={demoDay?.bookingDetails?.location?.join_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >Invitation Link</a>
                                    </strong>
                                </p>

                            </div>
                            <div className={st.actionButton}>
                                <Button
                                    size='small'
                                    className={st.button}
                                    style={{ marginTop: '1rem', width: 'auto', background: '#fff', color: '#000000', border: '0.7px solid #9A9A9A' }}
                                    variant="primary"
                                    onClick={() => navigate('/demo-day', { replace: true })} >
                                    Back to Home
                                </Button>
                            </div>
                        </div>
                        <div className={st.right}>
                            <img
                                src={machine}
                                alt="No Ventures Illustration"
                            />
                        </div>
                    </>}
                </section>
            </div>
        </div >
    );
};

export default DemoDayDetails;
